import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "reply-option-container" }
const _hoisted_2 = { class: "reply-option-row" }
const _hoisted_3 = { class: "reply-option" }
const _hoisted_4 = { class: "reply-option-text" }
const _hoisted_5 = { class: "reply-option-icon reply-option-arrow" }
const _hoisted_6 = { class: "reply-option-transition" }
const _hoisted_7 = { class: "reply-option-icon reply-option-delete" }
const _hoisted_8 = { class: "reply-option-row reply-option-row-errors" }
const _hoisted_9 = { class: "reply-option" }
const _hoisted_10 = {
  key: 0,
  class: "help is-danger"
}
const _hoisted_11 = {
  key: 1,
  class: "help is-danger"
}
const _hoisted_12 = {
  key: 2,
  class: "help is-danger"
}
const _hoisted_13 = { class: "reply-option-transition" }
const _hoisted_14 = {
  key: 0,
  class: "help is-danger"
}
const _hoisted_15 = {
  key: 1,
  class: "help is-danger"
}
const _hoisted_16 = {
  key: 2,
  class: "help is-danger"
}

import { computed, PropType } from 'vue';
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import TextEditor from '@/features/bots/components/designer/TextEditor/TextEditor.vue';
import TransitionPicker from './TransitionPicker.vue';
import { QuickReplyViewModel } from '@/features/bots/models/designer';
import { TransitionViewModel } from '@/features/bots/models/designer/transitionViewModel';
import VuelidateUtil from '@shared/util/vuelidateUtil';
import { useStore } from 'vuex';


export default /*@__PURE__*/_defineComponent({
  __name: 'QuickReplyOption',
  props: {
  option: {
    type: Object as PropType<QuickReplyViewModel>,
    required: true,
  },
  index: {
    type: Number,
    required: true,
  },
  allOptions: {
    type: Array as PropType<QuickReplyViewModel[]>,
    required: true,
  },
  pattern: {
    type: String,
    default: '',
  },
  dataTypeErrorMessage: {
    type: String,
    default: '',
  },
  hasDataType: {
    type: Boolean,
    default: false,
  },
  isValidTransition: {
    type: Function as PropType<(transition: TransitionViewModel) => boolean>,
    required: true,
  },
},
  emits: ["text-updated", "transition-selected", "delete-option"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const store = useStore();

const validations = computed(() => ({
  option: {
    text: {
      required,
      isUnique(value: string) {
        return props.allOptions.filter((opt: QuickReplyViewModel) => opt.text === value).length <= 1;
      },
      matchesType(value: string) {
        return !props.pattern || !!value.match(props.pattern);
      },
    },
    transition: {
      type: {
        required,
      },
      isValidTransition(transition: TransitionViewModel) {
        return props.isValidTransition(transition);
      },
      payload: {
        payloadValid(payload: string) {
          return payload ? !store.getters.isTransitionPayloadInvalid(payload).value : true;
        },
      },
    },
  },
}));

const $v = useVuelidate(validations, { option: props.option });
const isTextRequiredInvalid = computed(() => VuelidateUtil.isRequiredInvalid($v, (v) => v.option.text));
const isTextUniqueInvalid = computed(() => VuelidateUtil.isValidationInvalid($v, (v) => v.option.text, 'isUnique'));
const isTextMatchesTypeInvalid = computed(
  () => props.hasDataType && VuelidateUtil.isValidationInvalid($v, (v) => v.option.text, 'matchesType'),
);
const isTransitionRequiredInvalid = computed(() => VuelidateUtil.isRequiredInvalid($v, (v) => v.option.transition));
const isTransitionValidInvalid = computed(() =>
  VuelidateUtil.isValidationInvalid($v, (v) => v.option.transition, 'isValidTransition'),
);
const isTransitionPayloadInvalid = computed(() =>
  VuelidateUtil.isValidationInvalid($v, (v) => v.option.transition, 'payloadValid'),
);

function textUpdated(text: string) {
  $v.value.option.text.$touch();
  emit('text-updated', props.index, text);
}

function transitionSelected(transition: TransitionViewModel) {
  $v.value.option.transition.$touch();
  emit('transition-selected', props.index, transition);
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_n_tooltip = _resolveComponent("n-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(TextEditor, {
            value: __props.option.text,
            "show-variable-picker": false,
            placeholder: 'Option',
            onTextUpdated: textUpdated
          }, null, 8, ["value"])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_n_tooltip, {
          position: "top",
          text: "Options will be presented to the visitor for them to select as their reply. When selected, the flow will transition to the corresponding path"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_font_awesome_icon, { icon: "chevron-right" })
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(TransitionPicker, {
          transition: __props.option.transition,
          onTransitionSelected: transitionSelected
        }, null, 8, ["transition"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("a", {
          class: "delete is-small",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('delete-option', __props.index)))
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        (isTextRequiredInvalid.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_10, "Must not be empty"))
          : _createCommentVNode("", true),
        (isTextUniqueInvalid.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_11, "Must be unique"))
          : _createCommentVNode("", true),
        (isTextMatchesTypeInvalid.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_12, "Must be a valid " + _toDisplayString(__props.dataTypeErrorMessage), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_13, [
        (isTransitionRequiredInvalid.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_14, "Must not be empty"))
          : _createCommentVNode("", true),
        (isTransitionValidInvalid.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_15, "Must transition to a live flow"))
          : _createCommentVNode("", true),
        (isTransitionPayloadInvalid.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_16, "Must not contain an invalid transition"))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})